import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { motion } from 'framer-motion';
import { FaPhone, FaArrowLeft, FaKey } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { storeReset, clearOtpStatus } from '../../../redux/Slices/storeAuthSlice';
import styles from './StoreForgotPassword.module.css';


const StoreForgotPassword = () => {
    const [phone, setPhone] = useState('');
    const [shake, setShake] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, otpSent } = useSelector((state) => state.storeAuth);

    useEffect(() => {
        // مسح حالة otpSent عند دخول الصفحة
        dispatch(clearOtpStatus());
    }, [dispatch]);

    useEffect(() => {
        if (otpSent) {
            toast.success('تم إرسال كود التحقق بنجاح', {
                autoClose: 1500,
                onClose: () => {
                    navigate('/store-otp', { state: { phone: phone, isForgotPassword: true } });
                }
            });
        }
    }, [otpSent, navigate, phone]);

    useEffect(() => {
        if (error) {
            setShake(true);
            toast.error(error, {
                autoClose: 1500
            });
            setTimeout(() => setShake(false), 500);
        }
    }, [error]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!phone) {
            setShake(true);
            toast.error('يرجى إدخال رقم الهاتف');
            setTimeout(() => setShake(false), 500);
            return;
        }

        dispatch(storeReset(phone));
    };

    const LoadingSpinner = () => (
        <div className="spinner-border text-light" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
            <span className="visually-hidden">Loading...</span>
        </div>
    );

    return (
        <div className="container-fluid d-flex p-0"
            style={{
                minHeight: '100vh',
                background: 'white'
            }}>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            
            {/* النموذج في المنتصف */}
            <div className="col-12 d-flex justify-content-center align-items-center px-4 my-5">
                <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    className={`card shadow-lg ${shake ? 'shake-animation' : ''}`}
                    style={{
                        width: '100%',
                        maxWidth: '450px',
                        border: 'none',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                    }}>

                    <div className="card-body p-5">
                        {/* زر العودة */}
                        <motion.button
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="btn btn-link p-0 mb-3"
                            onClick={() => navigate('/login')}
                            style={{ color: '#184194' }}>
                            <FaArrowLeft className="mx-2" />
                            العودة لتسجيل الدخول
                        </motion.button>

                        {/* أيقونة المفتاح */}
                        <motion.div
                            initial={{ scale: 0.9 }}
                            animate={{ scale: 1 }}
                            transition={{ delay: 0.3, type: 'spring' }}
                            className="text-center mb-4">
                            <div className={styles.iconContainer}>
                                <FaKey className={styles.icon} />
                            </div>
                        </motion.div>

                        {/* عنوان نسيت كلمة المرور */}
                        <motion.h3
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.4 }}
                            className="text-center mb-3 fw-bold"
                            style={{ color: '#333' }}>
                            نسيت كلمة المرور؟
                        </motion.h3>

                        {/* نص التعليمات */}
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5 }}
                            className="text-center mb-4"
                            style={{ 
                                color: '#184194',
                                fontSize: '1rem',
                                fontWeight: '500'
                            }}>
                            أدخل رقم الهاتف المرتبط بحسابك وسنرسل لك كود التحقق لإعادة تعيين كلمة المرور
                        </motion.p>

                        <form onSubmit={handleSubmit}>
                            {/* حقل رقم الهاتف */}
                            <motion.div
                                initial={{ x: -20, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                transition={{ delay: 0.6 }}
                                className="mb-4">
                                <label htmlFor="phone" className="form-label fw-medium" style={{ color: '#333' }}>
                                    رقم الهاتف
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light">
                                        <FaPhone className="text-secondary" />
                                    </span>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        placeholder="ادخل رقم الهاتف "
                                        required
                                        style={{ 
                                            borderLeft: 'none',
                                            borderRadius: '0 8px 8px 0'
                                        }}
                                    />
                                </div>
                            </motion.div>

                            {/* زر إرسال كود التحقق */}
                            <motion.button
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                                type="submit"
                                className="btn w-100 text-white py-3 fw-medium"
                                style={{
                                    backgroundColor: '#184194',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: '1.1rem',
                                    marginTop: '1rem'
                                }}
                                disabled={loading}>
                                {loading ? <LoadingSpinner /> : 'إرسال كود التحقق'}
                            </motion.button>
                        </form>

                        {/* رابط العودة لتسجيل الدخول */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.7 }}
                            className="mt-4 text-center">
                            <button
                                type="button"
                                className="btn btn-link text-decoration-none"
                                onClick={() => navigate('/login')}
                                style={{ color: '#184194', fontSize: '0.9rem' }}>
                                تذكرت كلمة المرور؟ تسجيل الدخول
                            </button>
                        </motion.div>
                    </div>
                </motion.div>
            </div>

        </div>
    );
};

export default StoreForgotPassword;
